"use client";
import { jsx as s, jsxs as a } from "react/jsx-runtime";
import m from "clsx";
import { memo as o } from "react";
import { Box as r } from "../base/Base.js";
import { Button as w } from "../../buttons/button/Button.js";
import { InfoBox as P } from "../../buttons/info-box/v1/InfoBox.js";
import '../../assets/SubscribePack.css';const S = "_list_19m6i_1", k = "_item_19m6i_13", y = "_orange_19m6i_22", B = "_header_19m6i_22", I = "_violet_19m6i_26", L = "_content_19m6i_30", j = "_header__row_19m6i_39", q = "_header__title_19m6i_45", z = "_header__coins_19m6i_53", A = "_header__desc_19m6i_56", C = "_content__props_19m6i_71", D = "_badge_sale_19m6i_82", E = "_props_19m6i_103", F = "__bordered_19m6i_108", G = "_icon_19m6i_123", H = "_text_19m6i_130", J = "_price_19m6i_141", K = "_plate_19m6i_150", M = "_title_19m6i_170", e = {
  list: S,
  item: k,
  orange: y,
  header: B,
  violet: I,
  content: L,
  header__row: j,
  header__title: q,
  header__coins: z,
  header__desc: A,
  content__props: C,
  badge_sale: D,
  props: E,
  _bordered: F,
  icon: G,
  text: H,
  price: J,
  plate: K,
  title: M
}, O = o(({ children: _ }) => /* @__PURE__ */ s("div", { className: e.list, children: _ }));
O.displayName = "SubscribePackList";
const Q = o(
  ({
    href: _,
    color: i = "violet",
    coins: t,
    type: c = "vip",
    title: p,
    desc: n,
    buttonText: h,
    buttonColor: b = i,
    sale: l,
    loading: N,
    disabled: u,
    scroll: v = !0,
    onClick: g,
    children: x,
    ...f
  }) => {
    const d = /* @__PURE__ */ s(
      w,
      {
        href: _,
        text: h,
        color: b,
        onClick: g,
        loading: N,
        disabled: u,
        scroll: v,
        wide: !0
      }
    );
    return /* @__PURE__ */ a("div", { className: m(e.item, e[i]), ...f, children: [
      /* @__PURE__ */ a("div", { className: e.header, children: [
        /* @__PURE__ */ a("div", { className: e.header__row, children: [
          /* @__PURE__ */ s("span", { className: e.header__title, children: p }),
          t && /* @__PURE__ */ s(
            P,
            {
              iconLeft: c === "vip" ? "diamond" : "star",
              color: c === "vip" ? "orange" : "violet",
              text: t,
              className: e.header__coins
            }
          )
        ] }),
        n && /* @__PURE__ */ s("span", { className: e.header__desc, children: n })
      ] }),
      /* @__PURE__ */ a("div", { className: e.content, children: [
        /* @__PURE__ */ s("div", { className: e.content__props, children: x }),
        l ? /* @__PURE__ */ s("span", { className: e.badge_sale, "data-sale": l, children: d }) : d
      ] })
    ] });
  }
);
Q.displayName = "SubscribePack";
const R = o(
  ({ icon: _, text: i, price: t, border: c }) => /* @__PURE__ */ a(
    r,
    {
      gap: 8,
      row: !0,
      className: m(e.props, { [e._bordered]: c }),
      children: [
        /* @__PURE__ */ s("span", { className: e.icon, children: _ }),
        /* @__PURE__ */ a(r, { gap: 12, row: !0, className: e.text, children: [
          /* @__PURE__ */ s("span", { children: i }),
          t && /* @__PURE__ */ s("span", { className: e.price, children: t })
        ] })
      ]
    }
  )
);
R.displayName = "SubscribePropsItem";
const T = o(
  ({ icon: _, title: i, text: t }) => /* @__PURE__ */ a(r, { gap: 0, row: !0, className: e.plate, children: [
    /* @__PURE__ */ s("span", { className: e.icon, children: _ }),
    /* @__PURE__ */ a(r, { gap: 12, className: e.content, children: [
      /* @__PURE__ */ s("span", { className: e.title, children: i }),
      t && /* @__PURE__ */ s("span", { className: e.text, children: t })
    ] })
  ] })
);
T.displayName = "SubscribePlate";
export {
  Q as SubscribePack,
  O as SubscribePackList,
  T as SubscribePlate,
  R as SubscribePropsItem
};
